import Backbone from 'backbone'

import store from '../../store'
import { GoodsModel } from '../../store/goods.model'

export var PokerClassCollection = Backbone.Collection.extend({
  model: GoodsModel,
  sync: function (method, model, options) {
    if (method === 'read') {
      options.success(store.list.get('pokerclass'))
    }
  },
})
